export const formatCashbackCurrency = (rewardValue: number, locale: string): string => {
    const cashbackToTwoDp: string = Number(rewardValue / 100).toFixed(2);
    return formatCashbackBalanceByLocale(cashbackToTwoDp, locale);
};
export const formatCashbackBalanceByLocale = (rewardsBalance: string, locale: string): string => {
    switch (locale.toUpperCase()) {
        case 'ES':
        case 'DE':
        case 'UK':
            return rewardsBalance.replace(/\./g, ',');
        default:
            return rewardsBalance;
    }
};
